import { useState } from "react";
import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS, WIDGETS_PER_PAGE } from "@utils/constants";
import { WidgetsCategoryModel, WidgetsMileageModel } from "@interfaces/models";
import { useUserStore } from "@stores/index";
import {
  WidgetItem,
  MileageSummaryWidget,
  ChevronSmallDownSvg,
} from "@components/index";

export const WidgetItemList = ({
  categories,
  mileage,
  businessId,
  startDate,
  endDate,
  onCategoryClick,
  onMileageClick,
}: {
  categories: WidgetsCategoryModel[] | undefined;
  mileage: WidgetsMileageModel | undefined;
  businessId: string;
  startDate: string;
  endDate: string;
  onCategoryClick: (category: WidgetsCategoryModel) => void;
  onMileageClick: (mileage: WidgetsMileageModel) => void;
}) => {
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });

  const puEnabled = useUserStore(({ puEnabled }) => puEnabled);
  const disabledFeatures = useUserStore(
    ({ disabledFeatures }) => disabledFeatures,
  );
  const [countWidgetItems, setCountWidgetItems] = useState(WIDGETS_PER_PAGE);

  const mileageWidgetShown =
    !disabledFeatures.includes("Mileage Log") &&
    !!mileage &&
    mileage.items.length !== 0;

  if (isMobile) {
    return (
      <div className="flex flex-col gap-2">
        {categories?.map(
          (category, index) =>
            index < countWidgetItems && (
              <WidgetItem
                key={category.uniqueId}
                businessId={businessId}
                startDate={startDate}
                endDate={endDate}
                widget={category}
                puEnabled={puEnabled}
                onDetails={() => onCategoryClick(category)}
              />
            ),
        )}
        {mileageWidgetShown && (
          <MileageSummaryWidget
            summary={mileage.summary}
            onDetails={() => onMileageClick(mileage)}
          />
        )}
        {!!categories?.length && countWidgetItems < categories.length && (
          <div className="flex justify-center pt-4 font-bold text-primary-300">
            <button
              type="button"
              className="flex flex-col items-center"
              onClick={() =>
                setCountWidgetItems(countWidgetItems + WIDGETS_PER_PAGE)
              }
            >
              <div>Show More</div>
              <ChevronSmallDownSvg />
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="ml-1.5 grid flex-1 auto-cols-[20rem] grid-flow-col grid-rows-2 gap-2 overflow-x-auto">
      {categories?.map((category) => (
        <WidgetItem
          key={category.uniqueId}
          businessId={businessId}
          startDate={startDate}
          endDate={endDate}
          widget={category}
          puEnabled={puEnabled}
          onDetails={() => onCategoryClick(category)}
        />
      ))}
      {mileageWidgetShown && (
        <MileageSummaryWidget
          summary={mileage.summary}
          onDetails={() => onMileageClick(mileage)}
        />
      )}
    </div>
  );
};
